var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',[_c('a-row',{staticClass:"content-title",attrs:{"type":"flex"}},[_c('h2',[_vm._v("Статистика")])]),_c('statistics-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }